export default "__VITE_ASSET__BvQK8SOI__"